<script setup lang="ts">
import { UiDivider, UiText } from "@shopexperts/shared";

const props = defineProps<{
    title: string;
    subtitle?: string;
}>();
</script>

<template>
    <section class="flex flex-col gap-6 rounded-lg border border-se-gray-300 bg-se-secondary-background p-4">
        <div class="flex flex-col gap-2">
            <UiText as="h3" variant="h6" class="font-semibold text-se-dark" :text="props.title" />
            <UiText v-if="props.subtitle" as="p" variant="small" class="text-se-gray-700" :text="props.subtitle" />
            <UiDivider spacing="none" />
        </div>
        <slot />
    </section>
</template>
